import { cn } from "@/lib/utils";
import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const H1 = (props: Props) => {
  return (
    <h1
      className={cn(
        "font-semibold text-2xl !leading-relaxed md:text-4xl lg:text-5xl",
        props.className
      )}
    >
      {props.children}
    </h1>
  );
};

export const H2 = (props: Props) => {
  return (
    <h2 className={cn("lg:text-[40px] md:text-3xl text-xl", props.className)}>
      {props.children}
    </h2>
  );
};
export const H3 = (props: Props) => {
  return (
    <h3
      className={cn(
        "lg:text-[32px] lg:leading-[51.2px] md:text-2xl text-base leading-[25.6px]",
        props.className
      )}
    >
      {props.children}
    </h3>
  );
};

export const H4 = (props: Props) => {
  return (
    <h4
      className={cn(
        "lg:text-2xl lg:leading-[51.2px] md:text-xl text-sm leading-[25.6px] text-justify",
        props.className
      )}
    >
      {props.children}
    </h4>
  );
};

export const H5 = (props: Props) => {
  return (
    <h5
      className={cn("text-lg sm:leading-loose max-sm:text-xs", props.className)}
    >
      {props.children}
    </h5>
  );
};

export const LoginHeader = (props: Props) => {
  return (
    <p
      className={cn(
        "max-sm:text-center text-2xl font-medium max-sm:text-lg mb-4 sm:mb-8",
        props.className
      )}
    >
      {props.children}
    </p>
  );
};
